import React from 'react';

const BookingNextLoading = React.memo((props: { hide?: boolean }) => {
  const { hide } = props;
  return (
    <div className="step-loading" style={{ display: hide ? 'none' : 'block' }}>
      <div className="step-loading__content is-flex-mid">
        <span>loading...</span>
      </div>
    </div>
  );
});

export default BookingNextLoading;
